export default {
    sih_url: "",
    sih_id: "",
    sih_type: "",
    sih_group_id: "",
    tamm_patient_id: "",
    sih_cabinet_id: "",
}
